const navigation = {
  sections: {
    contentOperations: "Content operations",
    personalSetup: "Personal setup",
    systemAdministration: "System administration",
  },
  items: {
    dashboard: "Dashboard",
    contentInbox: "My Content Inbox",
    promotions: "Promotions",
    publishingHistory: "Publishing History",
    sources: "My Sources",
    filters: "My Filters",
    destinations: "My Destinations",
    aiConfiguration: "My AI Configuration",
    teamAccess: "Team & Access",
    systemSettings: "System Settings",
  },
  titles: {
    dashboard: "Dashboard",
    feed: "My Content Inbox",
    history: "Publishing History",
    promotion: "Promotions",
    channels: "Source Channels",
    filters: "Content Filters",
    destination: "My Destinations",
    ai: "AI Configuration",
    team: "Team & Access",
    database: "System Settings",
  },
  mobile: {
    home: "Home",
    inbox: "Inbox",
    promotions: "Promotions",
    more: "More",
    moreDescription: "History and workspace settings",
  },
  account: {
    administrator: "Administrator",
    systemOwner: "System owner",
    personalWorkspace: "Personal workspace",
    contentAdmin: "Content admin",
    owner: "Owner",
    admin: "Admin",
  },
  status: {
    workspace: "AI Powered Telegram content operations",
    publishingSetupRequired: "Publishing setup required",
    publishingTargetsReady_one: "{{count}} publishing target ready",
    publishingTargetsReady_other: "{{count}} publishing targets ready",
    secureWorkspace: "Secure workspace",
    targetsReady_one: "{{count}} target ready",
    targetsReady_other: "{{count}} targets ready",
  },
  accessibility: {
    openDashboard: "Open TGReposter dashboard",
    closeSidebar: "Close sidebar",
    openSidebar: "Open sidebar",
    primaryNavigation: "Primary navigation",
    signOut: "Sign out",
    closeMoreNavigation: "Close more navigation",
    mobileNavigation: "Mobile navigation",
    openPromotionCenter: "Open Promotion Center",
  },
} as const;

export default navigation;
